module.exports = __webpack_public_path__ + "static/media/gold.5c90e516.svg";